import { Target, Award } from "lucide-react";

export default function WeeklyChallenge({ challenge }) {
  const pct = Math.round((challenge.progress / challenge.target) * 100);
  return (
    <section className="rounded-2xl bg-white border border-[#0E395F]/10 p-5" data-testid="challenge-card">
      <div className="flex items-center justify-between">
        <span className="text-xs font-black uppercase tracking-widest text-[#5C7285] inline-flex items-center gap-1">
          <Target size={13} className="text-[#F5B700]" />Weekly Challenge
        </span>
        <span className="text-xs font-bold text-[#F5B700] inline-flex items-center gap-1"><Award size={13} />+{challenge.reward_xp} XP</span>
      </div>
      <div className="font-bold pv-text-dark mt-2">{challenge.title}</div>
      <div className="flex items-center justify-between text-xs text-[#5C7285] mt-2 mb-1">
        <span>{challenge.progress} / {challenge.target} complete</span>
        <span>{pct}%</span>
      </div>
      <div className="h-2.5 rounded-full bg-[#0E395F]/10 overflow-hidden" data-testid="challenge-progress-bar">
        <div className="h-full rounded-full bg-[#BED445] transition-all" style={{ width: `${pct}%` }} />
      </div>
      {challenge.done && <div className="mt-3 text-xs font-bold text-[#005F19]" data-testid="challenge-done">Challenge complete — reward unlocked!</div>}
    </section>
  );
}
